import { styled, Style } from 'inlines'
import { createElement } from 'react'
import { AL } from '../assets/flags/AL.js'
import { AM } from '../assets/flags/AM.js'
import { AT } from '../assets/flags/AT.js'
import { AU } from '../assets/flags/AU.js'
import { AZ } from '../assets/flags/AZ.js'
import { BE } from '../assets/flags/BE.js'
import { BG } from '../assets/flags/BG.js'
import { CH } from '../assets/flags/CH.js'
import { CY } from '../assets/flags/CY.js'
import { CZ } from '../assets/flags/CZ.js'
import { DE } from '../assets/flags/DE.js'
import { DK } from '../assets/flags/DK.js'
import { EE } from '../assets/flags/EE.js'
import { ES } from '../assets/flags/ES.js'
import { FI } from '../assets/flags/FI.js'
import { FR } from '../assets/flags/FR.js'
import { GB } from '../assets/flags/GB.js'
import { GE } from '../assets/flags/GE.js'
import { GR } from '../assets/flags/GR.js'
import { HR } from '../assets/flags/HR.js'
import { IE } from '../assets/flags/IE.js'
import { IL } from '../assets/flags/IL.js'
import { IS } from '../assets/flags/IS.js'
import { IT } from '../assets/flags/IT.js'
import { LT } from '../assets/flags/LT.js'
import { LU } from '../assets/flags/LU.js'
import { LV } from '../assets/flags/LV.js'
import { MD } from '../assets/flags/MD.js'
import { ME } from '../assets/flags/ME.js'
import { MT } from '../assets/flags/MT.js'
import { NL } from '../assets/flags/NL.js'
import { NO } from '../assets/flags/NO.js'
import { PL } from '../assets/flags/PL.js'
import { PT } from '../assets/flags/PT.js'
import { RO } from '../assets/flags/RO.js'
import { RS } from '../assets/flags/RS.js'
import { RoW } from '../assets/flags/RoW.js'
import { SE } from '../assets/flags/SE.js'
import { SI } from '../assets/flags/SI.js'
import { SM } from '../assets/flags/SM.js'
import { UA } from '../assets/flags/UA.js'

const flags = {
  AL,
  AM,
  AT,
  AU,
  AZ,
  BE,
  BG,
  CH,
  CY,
  CZ,
  DE,
  DK,
  EE,
  ES,
  FI,
  FR,
  GB,
  GE,
  GR,
  HR,
  IE,
  IL,
  IS,
  IT,
  LT,
  LU,
  LV,
  MD,
  ME,
  MT,
  NL,
  NO,
  PL,
  PT,
  RO,
  RS,
  RoW,
  SE,
  SI,
  SM,
  UA,
}

type FlagProps = {
  code?: string
  width?: number
  height?: number
  style?: Style
}

export const Flag = ({ code, width = 24, height = 24, style }: FlagProps) => {
  const el = code ? flags[code as keyof typeof flags] : undefined

  if (!el) {
    return null
  }

  return (
    <styled.svg
      width={width}
      height={height}
      viewBox="0 0 96 96 "
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        minWidth: width,
        minHeight: height,
        ...style,
      }}
    >
      {createElement(el)}
    </styled.svg>
  )
}
